// services/testCaseCommentService.js
import api from "./api";

/**
 * Add a comment or reply to a test case
 * @param {string} testCaseId - Test case ID
 * @param {string} commentText - Comment text content
 * @param {string|null} parentCommentId - Parent comment ID for replies (null for top-level comments)
 * @returns {Promise} API response
 */
export const addComment = async (
  testCaseId,
  commentText,
  parentCommentId = null,
) => {
  try {
    console.log("[testCaseCommentService] Adding comment:", {
      testCaseId,
      commentText,
      parentCommentId,
    });
    const response = await api.post("api/test-case/comments/add", {
      testCaseId,
      commentText,
      parentCommentId,
    });
    console.log(
      "[testCaseCommentService] Comment added successfully:",
      response.data,
    );
    return response.data;
  } catch (error) {
    console.error("[testCaseCommentService] Error adding comment:", error);
    console.error("[testCaseCommentService] Error details:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    throw error;
  }
};

/**
 * Get all comments for a test case (tree format)
 * @param {string} testCaseId - Test case ID
 * @returns {Promise} API response with comments tree
 */
export const getComments = async (testCaseId) => {
  try {
    const response = await api.post("api/test-case/comments/list", {
      testCaseId,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting comments:", error);
    throw error;
  }
};

/**
 * Delete a comment (soft delete)
 * @param {string} commentId - Comment ID to delete
 * @returns {Promise} API response
 */
export const deleteComment = async (commentId) => {
  try {
    const response = await api.post("api/test-case/comments/delete", {
      commentId,
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting comment:", error);
    throw error;
  }
};

/**
 * Update a comment
 * @param {string} commentId - Comment ID to update
 * @param {string} commentText - New comment text
 * @returns {Promise} API response
 */
export const updateComment = async (commentId, commentText) => {
  try {
    const response = await api.post("api/test-case/comments/update", {
      commentId,
      commentText,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating comment:", error);
    throw error;
  }
};

/**
 * Get comment count for a test case
 * @param {string} testCaseId - Test case ID
 * @returns {Promise} API response with comment count
 */
export const getCommentCount = async (testCaseId) => {
  try {
    const response = await api.post("api/test-case/comments/count", {
      testCaseId,
    });
    return response.data;
  } catch (error) {
    console.error("Error getting comment count:", error);
    throw error;
  }
};

const testCaseCommentService = {
  addComment,
  getComments,
  deleteComment,
  updateComment,
  getCommentCount,
};

export default testCaseCommentService;
